(function () {
    'use strict';

    angular.module("imApp").factory("interBranchInvoicingService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 794,
                    parameters: parms || {}
                });
            },
            createNewInvoice: function (setting) {
                return $ihttp.post({
                    method: 795,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
